import logoImage from '../../../assets/icons/logo/Logo.svg'; 
import './style.scss'; 

const Logo = () => {
    return (
        <div className="logo">
            <img src={logoImage} alt="App Logo" />
        </div>
    );
};
export default Logo;
